































































































































































































import { Component, Vue } from "vue-property-decorator";
import {
  Button,
  Cell,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  Empty,
  Field,
  Icon,
  Popup,
  Search,
  Toast,
  Uploader
} from "vant";
import i18n from "@/locales";
import UploadImg from "@/views/open-account/components/UploadImg.vue";
import NavButtons from "@/views/open-account/components/navButtons.vue";
import pinyin from "pinyin";

const CURRENCY_MAP = {
  HKD: i18n.t("common.hkd"),
  USD: i18n.t("common.usd"),
  CNH: i18n.t("common.rmb")
};

@Component({
  components: {
    NavButtons,
    UploadImg,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Field.name]: Field,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [Uploader.name]: Uploader,
    [Popup.name]: Popup,
    [Search.name]: Search,
    [Icon.name]: Icon,
    [Empty.name]: Empty,
  }
})
export default class BankcardAdd extends Vue {
  bank_name: any = "";
  bank_name_text: string = '';
  bank_code: any = "";
  bank_id: any = "";
  other_bank_name: any = "";
  bank_card: any = "";
  cn_name: any = "";
  en_name: any = "";
  swift_code: any = "";
  cardId: any = "";
  currency: any = [];
  currencyList: any = CURRENCY_MAP;
  bank_img = '';
  bank_img_show = '';
  uploadLoading: any = null;
  inputFocusId:any = 0;
  isClickNext = false;
  bankCardUploadImg = require("@/assets/images/bank-cark-upload-bg.png");
  showPopup:boolean = false;
  showPopupType: string = "";
  bankListData: any[] = [];
  popupSearchValue: string = "";
  hasAccount: boolean = false;
  showAccountTipPopup: boolean = false;
  delImg(){
    this.bank_img = ''
    this.bank_img_show = ''
  }
  afterRead(res) {
    this.bank_img = res.content;
    this.bank_img_show = res.url || res.base64 || '';
  }
  formatterBackCard(e){
    let cleaned = e.replace(/[^A-Za-z0-9 ]/g, '');
    cleaned = cleaned.replace(/\s/g, '');
    return cleaned.match(/.{1,4}/g)?.join(' ') || '';
  }
  inputFocus(id){
    this.inputFocusId = id;
  }
  inputBlur(){
    this.inputFocusId = null;
  }
  get computedDisabled() {
    const baseValid = this.en_name && this.bank_name && this.bank_card && this.currency.length && this.bank_img_show;
    if (this.bank_id == 54) {
      return !(baseValid && this.other_bank_name);
    }
    return !baseValid;
  }

  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }

  created() {
    const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
    const { real_name: cn_name, english_name: en_name } = userInfo;
    // if (!cn_name && !en_name) {
    //   Toast.fail(this.$t("bankCard.domText[8]"));
    //   return;
    // }
    this.getBankList()
    this.cn_name = cn_name;
    this.en_name = en_name;
    this.getAccountSituationV2();
    this.cardId = this.$route.query.id;
    this.cardId && this.getBankCardData();
  }
  getAccountSituationV2(){
    (this as any).$apis.accountSituationV2().then(res => {
      this.en_name = res.english_name;
      (this as any).hasAccount = res.account_list && res.account_list.length > 0;
    })
  }
  // 银行枚举
  getBankList(){
    (this as any).$apis.getEnum({
      key: 'funds_bank'
    }).then(res => {
      this.bankListData = res;
    });
  }

  get popupTitle(){
    const titles = {
      en_name: {
        title: this.$t('mki18n.t00007'),
        placeholder: this.$t('mki18n.t00008')
      },
      bank_name: {
        title: this.$t('mki18n.t00009'),
        placeholder: this.$t('mki18n.t00010')
      }
    };
    return titles[this.showPopupType];
  }

  get popupActions(){
    const actions:any = {
      en_name: [],
      bank_name: this.bankListData
    };
    if(this.showPopupType == 'en_name'){
      const pinyinArr = pinyin(this.cn_name, { style: pinyin.STYLE_NORMAL });
      const res = pinyinArr.map((item:any) => {
        return item[0];
      });
      actions.en_name[0] = {
        value_display: res.join(' ')
      };
      if(res.length > 2){
        actions.en_name[1] = {
          value_display: [res.slice(1, res.length).join(' '), res[0]].join(' ')
        };
        actions.en_name[2] = {
          value_display: [res[0], res.slice(1, res.length).join('')].join(' ')
        };
        actions.en_name[3] = {
          value_display: [res[0], res.slice(1, res.length).join('')].reverse().join(' ')
        };
      }else{
        actions.en_name[1] = {
          value_display: res.reverse().join(' ')
        };
      }
      // 再来小写的
      const res2 = JSON.parse(JSON.stringify(actions.en_name)).map(item => {
        item.value_display = item.value_display.toUpperCase();
        return item;
      });
      actions.en_name = [ ...res2, ...actions.en_name];
    }
    return actions[this.showPopupType]
  }

  selectActions(e){
    if(this.showPopupType == 'en_name'){
      this.en_name = e.value_display;
    }else{
      this.bank_name = e.value_display;
      this.bank_code = e.remark || '';
      this.bank_id = e.value || '';
    }
    this.showPopup = false;
  }
  submitPopText(){
    if(!this.popupSearchValue) return;
    if(this.showPopupType == 'en_name'){
      this.en_name = this.popupSearchValue;
    }else{
      this.bank_name = this.popupSearchValue;
    }
    this.showPopup = false;
  }
  changeSearch(){

  }
  // 搜索结果无数据
  get searchEmpty(){
    if(!this.popupSearchValue) return false;
    return !this.popupActions.some(item => (item.value && item.value.indexOf(this.popupSearchValue) > -1) || (item.value_display && item.value_display.indexOf(this.popupSearchValue) > -1));
  }


  openPopup(type: string) {
    this.popupSearchValue = '';
    this.showPopupType = type;
    this.showPopup = true;
  }

  getBankCardData() {
    const params = {
      id: this.cardId
    };
    (this as any).$apis
      .getBankCardInfo(params)
      .then(res => {
        const { bank_name, bank_card, currency_type, bank_img_url, bank_img, holder_name, remark, bank_id, other_bank_name } = res;
        this.bank_name = bank_name;
        this.bank_code = remark || '';
        this.bank_id = bank_id || '';
        this.other_bank_name = other_bank_name || '';
        this.bank_card = bank_card;
        if(holder_name){
          this.en_name = holder_name;
        }
        this.currency = currency_type ? currency_type.split(",") : [];
        // bank_img_url 为 [{content, url}]：url 用于回显（保留 query），content/bank_img 用于提交存储路径
        const bankImg: any = Array.isArray(bank_img_url) ? bank_img_url[0] || {} : {};
        this.bank_img = bankImg.content || bank_img || '';
        this.bank_img_show = bankImg.url || '';
      })
      .catch(err => {
        
      });
  }


  handleJumpNext() {
    this.isClickNext = true;
    if(this.computedDisabled){
      return false;
    }
    let params: any = {};
    if (this.cardId) {
      params = {
        bank_name: this.bank_name,
        bank_card: this.bank_card.replace(/\s/g, ''),
        currency_type: this.currency.join(","),
        modify_id: this.cardId,
        bank_img: this.bank_img,
        english_name: this.en_name,
        bank_id: this.bank_id,
        bank_code: this.bank_code
      };
    } else {
      params = {
        bank_name: this.bank_name,
        bank_card: this.bank_card.replace(/\s/g, ''),
        currency_type: this.currency.join(","),
        bank_img: this.bank_img,
        english_name: this.en_name,
        bank_id: this.bank_id,
        bank_code: this.bank_code
      };
    }
    if (this.bank_id == 54) {
      params.other_bank_name = this.other_bank_name;
    }
    (this as any).$apis
      .addBankCard(params)
      .then(() => {
        this.$toast(
          this.cardId
            ? this.$t("bankCard.domText[9]")
            : this.$t("bankCard.domText[10]")
        );
        setTimeout(() => {
          this.$router.go(-1);
          // (this as any).$router.push({ path: "/bank-card-list", query: { ...(this as any).$route.query } });
        }, 1000);
      })
      .catch(err => {
        
      });
  }
}
